import utils from '@eitje/utils'
import {date} from '@eitje/utils'

export const formatTime = value => {
	if (_.isNumber(value)) {
		return utils.minutesToString(value)
	} else {
		const dateTime = date(value)
		if (dateTime.isDateTime()) {
			const formatted = dateTime.format('HH:mm')

			// e.g. occurs when an end time is not visible due to the shift type's settings
			if (formatted === 'Invalid date') return null

			return formatted
		}
	}
	return null
}

export const TimeCell = ({getValue}) => {
	return formatTime(getValue())
}

export const formatTimeWithZero = value => {
	return _.isNumber(value) && utils.minutesToString(value)
}

export const TimeCellWithZero = ({getValue}) => {
	return formatTimeWithZero(getValue())
}
